module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oZzM88/tc-custom/9781634867429.jpg?1723403855110",
      "alt": "This image is the cover for the book A Not So Hollow Heart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Not So Hollow Heart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Mason’s more scared of love than he is of the walking dead."), _c('br'), _c('br'), _vm._v("Mason is facing more than one apocalypse. The darkest hours are those spent alone, when memories surface and the touch of his lost love can make the most erotic of dreams horrifying. He’d rather face danger than recollect how he loved Antonio and what he was prepared to give up for him. He’s never going to fall in love again ... a vow that wavers when he rescues Kyle."), _c('br'), _c('br'), _vm._v("Although Mason is certain luck had more to do with saving Kyle than anything he did, now he fears something more than the walking dead. He’s afraid giving in to lust may lead to love, if homophobic hatred doesn’t murder them first.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sharon Maria Bidwell\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0